export default {"src":"/_next/static/image/public/images/flags/flag_993.0ab79598012e912b99c112e693dd8b06.svg","height":16,"width":24};